import * as Views from "./views";
import * as Wizards from "./wizards";

const Module = {
    name: "legalentities",
    defaultRoutePath: "/legalentities/legalentity",
    menuItemScope: "legalentities",
    menuItemName: "legalentities",

    routes: [
        {
            path: "/legalentities/legalentity",
            protected: true,
            children: [
                {
                    index: true,
                    path: "",
                    Component: Views.Default,
                },
                {
                    path: "list",
                    Component: Views.List,
                },
            ],
        },
    ],
    drawerRoutes: [
        {
            path: "list",
            Component: Views.List,
        },
        {
            path: "detail",
            Component: Views.Detail,
        },
        {
            path: "create",
            Component: Views.Create,
        },
        {
            path: "saltedgeConnection",
            Component: Wizards.SaltedgeConnection,
        },
        {
            path: "genericFileAssociation",
            Component: Wizards.GenericFileAssociation,
        },
    ],

}

export default Module;
